import React from 'react';
import { Bell, Search, User } from 'lucide-react';
import { useSelector } from "react-redux";

const SearchBar = () => (
  <div className="relative w-64">
    <input
      type="text"
      placeholder="Search..."
      className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
    <Search className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
  </div>
);

const UserMenu = ({ name }) => (
  <div className="flex items-center space-x-2">
    <span className="text-sm font-medium text-gray-700">{name}</span>
    <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full">
      <User className="h-6 w-6" />
    </button>
  </div>
);

const Header = () => {
  const employeeDetails = useSelector((state) => state?.employeedata);
  const employeeName = employeeDetails?.name || "Guest"; // Fallback if name is undefined

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center flex-1">
          <SearchBar />
        </div>

        <div className="flex items-center space-x-4">
          <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-full">
            <Bell className="h-6 w-6" />
            <span className="absolute top-0 right-0 h-2 w-2 bg-red-500 rounded-full"></span>
          </button>
          <UserMenu name={employeeName} />
        </div>
      </div>
    </header>
  );
};

export default Header;
